import { OktaAuth } from '@okta/okta-auth-js';

const oktaAuth = new OktaAuth({
    issuer: `https://${process.env.REACT_APP_OKTA_DOMAIN}/oauth2/default`,
    clientId: process.env.REACT_APP_OKTA_CLIENT_ID, // Goe-Digital Advisor
    redirectUri: window.origin + '/login/callback',
    pkce: true,
    dpop: true,
    scopes: ['openid', 'email', 'offline_access'], // offline_access grants a refresh_token
    tokenManager: {
        storage: 'memory',
        secure: true,
        autoRenew: true,
        expireEarlySeconds: 120 // renew 2 minutes before expiry
    },
    cookies: {
        sameSite: 'lax'
    }
});

// Log token renewal errors so they surface in monitoring
oktaAuth.tokenManager.on('error', (err) => {
    console.error('Okta tokenManager error – token renewal failed', err);
});

oktaAuth.tokenManager.on('renewed', (key: string) => {
    console.log(`Okta token renewed: ${key}`); // intentionally not logging token value
});

export default oktaAuth;
